import { StatusColor } from '@enums/status-color.enum';
import { ContractReminderStatus } from '@gi/enums/contract-reminder-status.enum';

export const CONTRACT_REMINDER_STATUS_COLOR: Record<ContractReminderStatus, StatusColor> = {
  [ContractReminderStatus.done]: StatusColor.accent,
  [ContractReminderStatus.todo]: StatusColor.orange,
  [ContractReminderStatus.coming]: StatusColor.grey3,
  [ContractReminderStatus.late]: StatusColor.warn
};
